// Shared dashboard utilities + small UI components used across pages.
import * as React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

type TFn = (key: string, options?: any) => string;

export function formatAgo(ts: number, t?: TFn): string {
  const sec = Math.floor((Date.now() - ts) / 1000);
  if (sec < 5) return t ? t("ago.just_now") : "just now";
  if (sec < 60) return t ? t("ago.seconds", { n: sec }) : `${sec}s ago`;
  const m = Math.floor(sec / 60);
  return t ? t("ago.minutes", { n: m }) : `${m}m ago`;
}

export function Empty({ children }: { children: React.ReactNode }) {
  return <div className="px-4 py-6 text-sm text-slate-500 text-center">{children}</div>;
}

export function PriorityBadge({ priority }: { priority: string }) {
  return (
    <Badge variant={priority === "P0" ? "red" : priority === "P1" ? "amber" : "default"}>
      {priority}
    </Badge>
  );
}

export function TierBadge({ tier }: { tier: number }) {
  return (
    <Badge variant={tier === 3 ? "red" : tier === 2 ? "amber" : "default"}>T{tier}</Badge>
  );
}

export function MiniKPI({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) {
  return (
    <Card className="p-3">
      <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
      <div className="text-lg font-semibold tabular-nums mt-0.5">{value}</div>
    </Card>
  );
}
